import { selectableNetworks } from '@polkadot/networks';
import { objectSpread } from '@polkadot/util';
export const chains = /*#__PURE__*/ selectableNetworks
    .filter((n) => n.genesisHash.length)
    .reduce((chains, { genesisHash, network }) => objectSpread(chains, { [network]: genesisHash }), {});
